module.exports = __webpack_public_path__ + "img/ys@2x.e4f7adc0.png";